import "./assets/scss/style.scss";

import React from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { register } from "swiper/element/bundle";
import {CookiesProvider} from 'react-cookie';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://ae6d06c6251991aef4b8ef875aa2098c@sentry.star-workflow.com/632",
  sendDefaultPii: true
});

register();

import App from "./App";

function AppWithUI() {
    return (
        <CookiesProvider>
            <React.StrictMode>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </React.StrictMode>
        </CookiesProvider>
    );
}

ReactDOM.createRoot(document.getElementById("root")).render(<AppWithUI />);
